import CardHeader from "../atoms/cardHeader";
import moment from "moment";

export const ShipmentHistory = ({ shipmentHistory }) => {
  return (
    <div className="card card-custom mb-5">
      <CardHeader name={"Shipment History"} />
      <div className="border-top-0">
        <table className="table table-bordered m-0 border radius-remove">
          <thead>
            <tr>
              <th className="align-middle w-200px">Shipment Assigned Date</th>
              <th className="align-middle w-200px">Shipment Provider</th>
              <th className="align-middle">Shipment Cancelled Date</th>
            </tr>
          </thead>
          <tbody>
            {[...shipmentHistory]
              ?.filter((d) => d?.status !== "ACTIVE")
              .sort(
                (a, b) => new Date(b.cancelledDate) - new Date(a.cancelledDate)
              )
              .map((datalist) => (
                <tr key={datalist.id || datalist.orderRefID}>
                  <td className="align-middle">
                    {moment
                      .utc(datalist.orderPackedDate)
                      .local()
                      .format("DD-MM-YYYY  hh.mm A")}
                  </td>
                  <td className="align-middle">
                    {datalist.deliveryMode === "SELF"
                      ? "SELF"
                      : datalist.shipmentProvider === null
                      ? "APNI KHETI"
                      : datalist.shipmentProvider}
                  </td>
                  <td className="align-middle">
                    {moment
                      .utc(datalist.cancelledDate)
                      .local()
                      .format("DD-MM-YYYY  hh.mm A")}
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
